// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Receipt20 from './Receipt20.tsx';
import Receipt20Filled from './Receipt20Filled.tsx';
import Receipt20CircleFilled from './Receipt20CircleFilled.tsx';
import Receipt24 from './Receipt24.tsx';
import Receipt24Filled from './Receipt24Filled.tsx';
import Receipt24CircleFilled from './Receipt24CircleFilled.tsx';
import Receipt40 from './Receipt40.tsx';
import Receipt40Filled from './Receipt40Filled.tsx';
import Receipt48 from './Receipt48.tsx';
import Receipt48Filled from './Receipt48Filled.tsx';

type ReceiptProps = {
    variation:
        | '20'
        | '20Filled'
        | '20CircleFilled'
        | '24'
        | '24Filled'
        | '24CircleFilled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Receipt20,
    Receipt20Filled,
    Receipt20CircleFilled,
    Receipt24,
    Receipt24Filled,
    Receipt24CircleFilled,
    Receipt40,
    Receipt40Filled,
    Receipt48,
    Receipt48Filled,
};

const Receipt: FC<ReceiptProps> = ({ variation, ...props }) => {
    const variationKey = `Receipt${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Receipt" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Receipt;
